export class SalesDetail {
  aircon: string;
  carImageUrls: string;
  caution: string;
  caution2: string;
  colorNm: string;
  colorNo: string;
  displacement: string;
  doorsAndShape: string;
  drive: string;
  equipmentMemo: string;
  equipments: string[];
  favoritesA: string;
  favoritesB: string;
  favoritesC: string;
  favoritesD: string;
  fuel: string;
  gradeAppend: string;
  gradeNm: string;
  kaijouNm: string;
  katashiki: string;
  loadCapacity: string;
  makerNm: string;
  modelNm: string;
  nenshiki: string;
  place: string;
  price: string;
  ratingInside: string;
  ratingMain: string;
  ratingOutside: string;
  repair: string;
  salesPoint: string;
  seatCapacity: string;
  shadaiNo: string;
  shakenKigen: string;
  shareki: string;
  shiftNm: string;
  soukouKm: string;
  stateImageUrl: string;
  stockGroupKbn: string;
  stockNo: string;

  constructor(json?: {
    aircon?: string;
    carImageUrls?: string;
    caution?: string;
    caution2?: string;
    colorNm?: string;
    colorNo?: string;
    displacement?: string;
    doorsAndShape?: string;
    drive?: string;
    equipmentMemo?: string;
    equipments?: string[];
    favoritesA?: string;
    favoritesB?: string;
    favoritesC?: string;
    favoritesD?: string;
    fuel?: string;
    gradeAppend?: string;
    gradeNm?: string;
    kaijouNm?: string;
    katashiki?: string;
    loadCapacity?: string;
    makerNm?: string;
    modelNm?: string;
    nenshiki?: string;
    place?: string;
    price?: string;
    ratingInside?: string;
    ratingMain?: string;
    ratingOutside?: string;
    repair?: string;
    salesPoint?: string;
    seatCapacity?: string;
    shadaiNo?: string;
    shakenKigen?: string;
    shareki?: string;
    shiftNm?: string;
    soukouKm?: string;
    stateImageUrl?: string;
    stockGroupKbn?: string;
    stockNo?: string;
  }) {
    // console.log(json);
    if (!json) {
      return;
    }
    this.aircon = json.aircon;
    this.carImageUrls = json.carImageUrls;
    this.caution = json.caution;
    this.caution2 = json.caution2;
    this.colorNm = json.colorNm;
    this.colorNo = json.colorNo;
    this.displacement = json.displacement;
    this.doorsAndShape = json.doorsAndShape;
    this.drive = json.drive;
    this.equipmentMemo = json.equipmentMemo;
    this.equipments = json.equipments;
    this.favoritesA = json.favoritesA;
    this.favoritesB = json.favoritesB;
    this.favoritesC = json.favoritesC;
    this.favoritesD = json.favoritesD;
    this.fuel = json.fuel;
    this.gradeAppend = json.gradeAppend;
    this.gradeNm = json.gradeNm;
    this.kaijouNm = json.kaijouNm;
    this.katashiki = json.katashiki;
    this.loadCapacity = json.loadCapacity;
    this.makerNm = json.makerNm;
    this.modelNm = json.modelNm;
    this.nenshiki = json.nenshiki;
    this.place = json.place;
    this.price = json.price;
    this.ratingInside = json.ratingInside;
    this.ratingMain = json.ratingMain;
    this.ratingOutside = json.ratingOutside;
    this.repair = json.repair;
    this.salesPoint = json.salesPoint;
    this.seatCapacity = json.seatCapacity;
    this.shadaiNo = json.shadaiNo;
    this.shakenKigen = json.shakenKigen;
    this.shareki = json.shareki;
    this.shiftNm = json.shiftNm;
    this.soukouKm = json.soukouKm;
    this.stateImageUrl = json.stateImageUrl;
    this.stockGroupKbn = json.stockGroupKbn;
    this.stockNo = json.stockNo;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/sales/sales-detail.ts